import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=479ac663&scoped=true"
import script from "./contact.ts?vue&type=script&lang=ts&external"
export * from "./contact.ts?vue&type=script&lang=ts&external"
import style0 from "./Contact.vue?vue&type=style&index=0&id=479ac663&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479ac663",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('479ac663')) {
      api.createRecord('479ac663', component.options)
    } else {
      api.reload('479ac663', component.options)
    }
    module.hot.accept("./Contact.vue?vue&type=template&id=479ac663&scoped=true", function () {
      api.rerender('479ac663', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/contact/Contact.vue"
export default component.exports